import routes from './RouterConfig'

//根据路径获取路由
const checkAuth = (routers: any, path: String) => {
    for (const data of routers) {
        if (data.path === path) return data
        if (data.children) {
            const res: any = checkAuth(data.children, path)
            if (res) return res
        }
    }
    return null
}

//路由鉴权
const checkRouterAuth = (path: String) => {
    let auth = null
    auth = checkAuth(routes, path)
    return auth
}

export { checkRouterAuth, checkAuth }
